<template>
  <div v-if="showItem">
    <v-autocomplete
      :disabled="disabled || item.readonly || lockItem"
      :items="elementiSorted"
      item-text="descrizione"
      item-value="codice"
      :value="item.value"
      :label="item.label"
      :rules="rulesValidation"
      :return-object="true"
      clearable
      @change="onChange"
      @click:clear="onClear"
      @focus="onFocus"
      @blur="onBlur"
      :ref="item.model"
    >
    </v-autocomplete>
  </div>
</template>

<script>
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import documenti from '@/services/documentiService.js'
  import { validazioni } from '@/mixins/validazioni.js'

  export default {
    name: 'distintaBase',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,
      disabled: { type: Boolean, default: false },
      updateTrigger: Number
    },
    data: (vm) => ({
      elementi: [],
      sourceArray: [],
      dialog: false,
      codice: '',
      descrizione: '',
      valoreInserito: '',
      oldValue: '',
      formAddFieldsValid: true
    }),
    async mounted() {
      let options = { page: 1 }
      let filtri = { tipoDocumento : ['distintaBase']  }
          
      const data = await documenti.getFilteredDocumentHeaders(filtri, options)
      const distinte = data && data.total_rows > 0 ? data.rows : []
      this.elementi = distinte.map(x => { return { codice: x._id, descrizione: (x.custom && x.custom.info) || x._id }}) 
    },
    watch:{
      updateTrigger() {
        this.$forceUpdate()
      }
    },
    computed: {
      showItem() {
        if (this.item && this.item.showIf) {
          return _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      },
      lockItem() {
        if (this.item && this.item.lockIf) {
          return !!_.get(this, this.item.lockIf, false)
        } else {
          return false
        }
      },
      elementiSorted() {
        const els = this.elementi
        const elSorted = els.sort(dynamicSortMultiple('descrizione'))
        return elSorted
      }    
    },
    methods: {
      onFocus(e) {
        this.oldValue = e.currentTarget.value
      },
      onBlur(e) {
        this.valoreInserito = e.currentTarget.value
        if (this.valoreInserito !== this.oldValue) {
          this.onChange(null, this.valoreInserito)
        }
      },
      onChange(item, descrizione) {
        if (item) {
          this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: item })
          this.oldValue = item.descrizione
        }
      },
      onClear() {
        this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value: null })
        this.oldValue = ''
      }
    }
  }
</script>
